import React, { Fragment } from 'react';
import { IReactAppError, IReactAppNotFoundProps, ReactAppErrorType, ReactAppRedirectError } from '@common/model/reactApp/error';
import { AppProvider as App } from 'src/app/providers/app';
import { ProvideExternalMode } from 'src/shared/ui/link';
import NotFoundPage from '../../../routes/notFound';
import ExceptionPage from '../../../routes/exception';
import RedirectPage from '../../../routes/redirect';

export const ErrorRenderer: React.FC<{ error: IReactAppError }> = ({ error }) => {
  let page: React.ReactNode;
  const AppProvider = error.providers?.app ? App : Fragment;

  if (error.type === ReactAppErrorType.PageNotFound) {
    page = <NotFoundPage {...(error.payload as IReactAppNotFoundProps)} />;
  } else if (error.type === ReactAppErrorType.Redirect) {
    page = <RedirectPage error={error as ReactAppRedirectError} />;
  } else {
    page = <ExceptionPage error={error} />;
  }

  return (
    <AppProvider>
      <ProvideExternalMode>{page}</ProvideExternalMode>
    </AppProvider>
  );
};
